import { Home } from "./components/Home";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  }
  
];

export default AppRoutes;
